import { useCallback } from 'react'
import { useEffectOnce } from '@chilecompra/react-kit'
import { REACT_APP_CAPTCHA_ENABLED, REACT_APP_CAPTCHA_SITE_KEY } from '../../config/settings/environment'

export const useReCaptcha = (isPrivate, action = 'newQuote') => {
  const executeReCaptcha = useCallback(() => {
    return new Promise(resolve => {
      if (!(isPrivate && REACT_APP_CAPTCHA_ENABLED === 'true') || typeof window === 'undefined' || !window.grecaptcha) {
        return resolve('')
      }

      return window.grecaptcha.enterprise.ready(() => {
        window.grecaptcha.enterprise
          .execute(REACT_APP_CAPTCHA_SITE_KEY, { action })
          .then(token => resolve(token))
          .catch(err => {
            console.error('Failed to get reCaptcha token', err)
            resolve('')
          })
      })
    })
  }, [isPrivate, action])

  return { executeReCaptcha }
}

/**
 * To initialize reCaptcha.
 */
export const initializeReCaptcha = (() => {
  let scriptLoaded = false

  return () => {
    if (REACT_APP_CAPTCHA_ENABLED !== 'true' || scriptLoaded || typeof window === 'undefined') {
      return
    }

    const script = document.createElement('script')
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${REACT_APP_CAPTCHA_SITE_KEY}`
    script.onload = () => {
      scriptLoaded = true
    }
    script.onerror = () => {
      console.error('Failed to load reCaptcha script')
    }
    document.body.appendChild(script)
  }
})()

/**
 * Hook to automatically initialize reCaptcha on mount.
 */
export const useReCaptchaInitialization = () => {
  useEffectOnce(() => {
    initializeReCaptcha()
  }, [])
}
